import { render, staticRenderFns } from "./PaymentMatchingLoanListItem.vue?vue&type=template&id=2d9872bc&lang=pug&"
import script from "./PaymentMatchingLoanListItem.vue?vue&type=script&lang=js&"
export * from "./PaymentMatchingLoanListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports